function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import PropTypes from 'prop-types';
import defaultProps from '../default-props';

const UndrawHomeRun = _props => {
  const props = Object.assign({}, _props);
  const primaryColor = props.primaryColor || defaultProps.primaryColor;
  const style = Object.assign({
    height: props.height || defaultProps.height,
    width: '100%'
  }, props.style);
  delete props.primaryColor;
  delete props.height;
  delete props.style;
  return React.createElement("svg", _extends({
    "data-name": "Layer 1",
    width: "1em",
    height: "1em",
    viewBox: "0 0 856 775",
    style: style
  }, props), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "prefix__a",
    x1: 719.25,
    y1: 837.5,
    x2: 719.25,
    y2: 62.5,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), React.createElement("linearGradient", {
    id: "prefix__b",
    x1: 778.25,
    y1: 304.36,
    x2: 778.25,
    y2: 86.44,
    xlinkHref: "#prefix__a"
  }), React.createElement("linearGradient", {
    id: "prefix__c",
    x1: 33.46,
    y1: 167.6,
    x2: 33.46,
    y2: 100.67,
    xlinkHref: "#prefix__a"
  })), React.createElement("path", {
    d: "M979.06 746.34l-.34.36L836 611.39l-19-85.7c0-.52.06-1 .07-1.55l-.89-4a67.67 67.67 0 0 0-6.53-29.2l15.65-148.85V340.23c0-2.55-.13-5.06-.37-7.54a37.22 37.22 0 0 0-.65-5 78.24 78.24 0 0 0-71.54-65.45v-13.5q3.2-1 6.26-2.22a43.41 43.41 0 0 0 19 4.16c10.16.26 22.66-3.55 32-19.85 18.61-32.57 64.2-58.62 36.29-84.67s-24.66-22.8-29.31-47-4.19-34-47-35.82c-11.37-.49-21.55-.85-30.42-.84-25.64-.11-40.76 2.66-42.16 13.87-1.86 14.89-58.48 1.69-23.19 61.79 0 0 .31.47.9 1.3a70.71 70.71 0 0 0 36.71 109.28v16.18a42.48 42.48 0 0 0-26.95 38.18l-98.75-46.82a13.74 13.74 0 0 0 1-2.66c-20.47-5.58-25.64 9.76-25.64 9.76 7.53 2.41 12.91 2 16.74.41l-4 11.73c-9.53-8.21-29.07-21.6-37.28-2-11.06 26.44 29.67 35.9 29.67 35.9l.08-.18 117.82 62.59-.2 1.76.47.25v114.7h-.47l.47.82v1.25l-178.54 157-34 174.07h-10.29a15.82 15.82 0 0 0-15.82 15.82h61.41l-2.79-15.82H489l15.47-.28 93.34-158.82 146.86-66.41 1.24 2.19.3-.14 56.28 99.71 157.25 67.92 5.44-5.18-15.88 16.43a15.82 15.82 0 0 0 .37 22.37l42.69-44.14z",
    transform: "translate(-172 -62.5)",
    fill: "url(#prefix__a)"
  }), React.createElement("path", {
    d: "M591.66 255.12l-58.34 61.85-130.26-92.77 9.5-28.2 111.26 52.75L571.48 196s22.21 27.29 20.18 59.12z",
    fill: "#535461"
  }), React.createElement("path", {
    d: "M532.41 316.97l58.34-61.85c1.38-21.55-8.35-41-14.78-51.33-.81 0-1.62-.06-2.44-.06h-9.94l-40.68 45-10.21-4.84v58.99z",
    opacity: 0.1
  }), React.createElement("path", {
    fill: "#4d8af0",
    d: "M513.12 425.2l115.51 204.65 153.71 66.39 19.1-18.19-140.07-132.79-26.38-119.15-121.87-.91z"
  }), React.createElement("path", {
    d: "M514.94 429.1l58.38 103.4 30.5-13.79a66.48 66.48 0 0 0 39.07-58.75l-7-31.59-119.46-.61z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M515.54 425.5L339 580.66l-33.29 170.45 31.61-.58 91.24-155.24 174.35-78.79A66.51 66.51 0 0 0 635 426.11z",
    fill: "#4d8af0"
  }), React.createElement("path", {
    d: "M635.45 429.3l-121.88-1.8V247.08a41.52 41.52 0 0 1 41.52-41.52h19.34a76.47 76.47 0 0 1 76.47 76.47z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M635.45 427.5l-121.88-1.82V245.26a41.52 41.52 0 0 1 41.52-41.52h19.34a76.47 76.47 0 0 1 76.47 76.47zM340.31 766.27h-60a15.46 15.46 0 0 1 15.46-15.46h41.84zM814.22 685.95l-41.74 43.15a15.46 15.46 0 0 1-.37-21.86l29.09-30.07z",
    fill: "#535461"
  }), React.createElement("path", {
    d: "M650.46 282.41l-78.22 61.85-59.12-31.41 5.72-51.19 40.67 14.38 30.44-25.13c24.61-20.31 62.23-2.08 60.63 29.79q-.05.85-.12 1.71z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M539.95 158.26h40v54.93a16 16 0 0 1-16 16h-8a16 16 0 0 1-16-16v-54.93z",
    fill: "#fda57d"
  }), React.createElement("path", {
    d: "M539.95 192.6a69.28 69.28 0 0 0 40 0v-32.52h-40z",
    opacity: 0.1
  }), React.createElement("circle", {
    cx: 559.96,
    cy: 124.6,
    r: 69.12,
    fill: "#fda57d"
  }), React.createElement("path", {
    d: "M503.18 82.68s24.49 36.92 47.23 29.64l34.87 75.87s30.62 16.9 48.81-14.93 62.76-57.3 35.47-82.77-45.48-22.74-50-46.39S636.81 11.37 595 9.55s-67.3-1.82-69.12 12.73-57.19 1.65-22.7 60.4z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M505 82.68s24.49 36.92 47.23 29.64l34.87 75.88s30.62 16.9 48.81-14.93 62.76-57.3 35.47-82.77-24.1-22.28-28.65-45.93-4.09-33.2-45.93-35-67.3-1.82-69.12 12.73-57.17 1.63-22.68 60.38z",
    fill: "#72351c"
  }), React.createElement("path", {
    fill: "#535461",
    d: "M541.49 229.2l38.48-25.27 11.82 12.54-25.47 25.46-24.83-12.73z"
  }), React.createElement("ellipse", {
    cx: 559.96,
    cy: 132.79,
    rx: 6.37,
    ry: 13.64,
    fill: "#fda57d"
  }), React.createElement("path", {
    d: "M1026.39 100.76a22.68 22.68 0 0 1-13 29.57l-475.82 174-9-21.88L996.62 88.18a22.68 22.68 0 0 1 29.77 12.58z",
    transform: "translate(-172 -62.5)",
    fill: "url(#prefix__b)"
  }), React.createElement("path", {
    d: "M851.21 39.5a22.38 22.38 0 0 1-12.88 29.19L368.66 240.5l-8.92-21.6L821.83 27.11a22.38 22.38 0 0 1 29.38 12.39z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M650.46 278.77l-78.22 61.85-174.63-92.77 12.73-28.2L559.5 272.4l30.44-25.13c24.61-20.31 62.23-2.08 60.63 29.79q-.04.86-.11 1.71z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M650.46 280.59l-78.22 61.85-174.63-92.78 12.73-28.16 149.16 52.72 30.44-25.13c24.61-20.31 62.23-2.08 60.63 29.79q-.04.86-.11 1.71z",
    fill: "#535461"
  }), React.createElement("path", {
    d: "M398.06 250.12s-39.81-9.25-29-35.09 41.73 6.9 41.73 6.9z",
    fill: "#fda57d"
  }), React.createElement("path", {
    d: "M418.07 195.5s-3.75 16.36-25.07 9.54c0 .05 5.06-14.95 25.07-9.54z",
    fill: "#fda57d"
  }), React.createElement("path", {
    d: "M116 118.83a31 31 0 0 1 33.05 11.57c3.5 5 5.51 10.95 9.64 15.39C169.14 157 188 153.55 201 145.5s24.15-19.77 38.83-24.07c8-2.34 16.45-2.27 24.77-2.19 16.78.17 34 .23 49.71-5.75",
    fill: "none",
    stroke: "#e6e6e6",
    strokeMiterlimit: 10
  }), React.createElement("path", {
    d: "M116 140.35a31 31 0 0 1 33.05 11.57c3.5 5 5.51 10.95 9.64 15.39 10.45 11.19 29.31 7.75 42.31-.26s24.15-19.77 38.83-24.07c8-2.34 16.45-2.27 24.77-2.19 16.78.17 34 .23 49.71-5.75",
    fill: "none",
    stroke: "#e6e6e6",
    strokeMiterlimit: 10
  }), React.createElement("circle", {
    cx: 33.46,
    cy: 134.14,
    r: 33.46,
    fill: "url(#prefix__c)"
  }), React.createElement("circle", {
    cx: 33.46,
    cy: 134.14,
    r: 31.65,
    fill: "#f5f5f5"
  }), React.createElement("path", {
    d: "M6.43 117.5s11.72 24.06.56 34.14",
    fill: "none",
    stroke: primaryColor,
    strokeMiterlimit: 10
  }), React.createElement("path", {
    d: "M6.59 121.23l1.22.91a5.2 5.2 0 0 1 2.39-2.35M7.12 123.9a4.46 4.46 0 0 1 2.15 1.61 4.82 4.82 0 0 1 2.28-2.9M8.95 127.58a3 3 0 0 1 1.56 1.66 22 22 0 0 1 2.49-2.59M9.58 130.86a3.4 3.4 0 0 1 1.58 2.44 7.12 7.12 0 0 1 2.86-2.36M10.05 135.3a1.06 1.06 0 0 1 1.06.47 3.12 3.12 0 0 1 .43 1.15 7 7 0 0 1 3.83-2.29M10.61 137.78a2.16 2.16 0 0 1 .69 1.79l3.94-1.34M10.34 142.03a4 4 0 0 1 .66 1.6 16.66 16.66 0 0 1 3.57-1.45M9.41 144.99a14.74 14.74 0 0 1 .11 2.62q2.18-.47 4.4-.78",
    fill: "none",
    stroke: primaryColor,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), React.createElement("path", {
    d: "M60.49 117.5s-11.72 24.06-.56 34.14",
    fill: "none",
    stroke: primaryColor,
    strokeMiterlimit: 10
  }), React.createElement("path", {
    d: "M60.33 121.23l-1.22.91a5.2 5.2 0 0 0-2.39-2.35M59.81 123.9a4.46 4.46 0 0 0-2.15 1.61 4.82 4.82 0 0 0-2.28-2.9M58 127.58a3 3 0 0 0-1.56 1.66 22 22 0 0 0-2.49-2.59M57.34 130.86a3.4 3.4 0 0 0-1.58 2.44 7.12 7.12 0 0 0-2.86-2.36M56.87 135.3a1.06 1.06 0 0 0-1.06.47 3.12 3.12 0 0 0-.43 1.15 7 7 0 0 0-3.83-2.29M56.31 137.78a2.16 2.16 0 0 0-.69 1.79l-3.94-1.34M56.59 142.03a4 4 0 0 0-.66 1.6 16.66 16.66 0 0 0-3.57-1.45M57.52 144.99a14.74 14.74 0 0 0-.11 2.62q-2.18-.47-4.4-.78",
    fill: "none",
    stroke: primaryColor,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }));
};

UndrawHomeRun.propTypes = {
  height: PropTypes.string,
  primaryColor: PropTypes.string
};
export default UndrawHomeRun;